module.exports = __webpack_public_path__ + "img/2025-ford-bronco-sport.f9dc5f6f.png";